import { useTranslation } from 'react-i18next'

/** Writing direction of the current language ('rtl' for Arabic). */
export function useDir(): 'rtl' | 'ltr' {
  const { i18n } = useTranslation()
  return i18n.dir(i18n.language)
}
